import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom'
import './index.css'
import App from './App.tsx'
import { SignInPage } from './pages/SignInPage'
import { SignUpPage } from './pages/SignUpPage'
import { ProtectedRoute } from './components/ProtectedRoute'
import { GuestRoute } from './components/GuestRoute'
import { ScanPage } from './pages/ScanPage'
import { InventoryTab } from './components/inventory/InventoryTab'
import { OffersTab } from './components/offer/OffersTab'
import { OfferEditPage } from './pages/OfferEditPage'
import { ImagesTab } from './components/ImagesTab'
import { CardMarketTab } from './components/cardlib/CardMarketTab'
import { CardDatabaseTab } from './components/cardlib/CardDatabaseTab'
import { TooltipProvider } from '@/components/ui/tooltip'
import * as Sentry from '@sentry/react'

Sentry.init({
  dsn: 'https://d3caadddd4c48ac124e15b18a69b9b36@o4504123604205568.ingest.us.sentry.io/4511356002762752',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <TooltipProvider>
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <App />
              </ProtectedRoute>
            }
          >
            <Route index element={<ScanPage />} />
            <Route path="scan" element={<ScanPage />} />
            <Route path="inventory" element={<InventoryTab />} />
            <Route path="offers" element={<Outlet />}>
              <Route index element={<OffersTab />} />
              <Route path=":id" element={<OfferEditPage />} />
            </Route>
            <Route path="images" element={<ImagesTab />} />
            <Route path="cardmarket" element={<CardMarketTab />} />
            <Route path="catalog" element={<CardDatabaseTab />} />
            <Route path="collection" element={<Navigate to="/" replace />} />
          </Route>
          <Route
            path="/sign-in"
            element={
              <GuestRoute>
                <SignInPage />
              </GuestRoute>
            }
          />
          <Route
            path="/sign-up"
            element={
              <GuestRoute>
                <SignUpPage />
              </GuestRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </StrictMode>,
)
